import { render } from "./AccordionPane.vue?vue&type=template&id=86f91252&scoped=true"
import script from "./AccordionPane.vue?vue&type=script&lang=js"
export * from "./AccordionPane.vue?vue&type=script&lang=js"

import "./AccordionPane.vue?vue&type=style&index=0&id=86f91252&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f91252"],['__file',"src/components/mdbvue/Advanced/AccordionPane.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "86f91252"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86f91252', __exports__)) {
    api.reload('86f91252', __exports__)
  }
  
  module.hot.accept("./AccordionPane.vue?vue&type=template&id=86f91252&scoped=true", () => {
    api.rerender('86f91252', render)
  })

}


export default __exports__